import React from "react";

interface Props {
  src: string;
  name: string;
  id: number;
  onClick: (id: number) => void;
  closePopup: (val: boolean) => void;
}

const DropdownChoice: React.FC<Props> = ({ src, name, id, onClick, closePopup }) => {
    const handleSelection = () => {
        onClick(id);
        closePopup(false);
    };
  return (
    <div className="flex items-center h-8 hover:bg-gray-100 hover:text-gray-900 cursor-pointer" role="menuitem" onClick={handleSelection}>
      <img src={src} className="h-8 w-8 mr-4 ml-4" alt="Team Logo" />
      <div>
        <h1 className="font-bold">{name}</h1>
      </div>
    </div>
  );
};
export default DropdownChoice;
